<!--
 * @Author: zhaoliang
 * @Date: 2024-05-08 18:13:54
 * @LastEditTime: 2024-06-07 16:24:03
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/LoungePrebook/SelectTime/index.vue
 *
-->

<template>
  <div class="select-container" v-clickOutside="closeOptions">
    <div class="select-wrapper" @click="openOptions" :class="{ error: errorStatus }">
      <div class="select-content" v-if="value">{{ value }}</div>
      <div class="select-content-placeholder" v-else>
        {{ $t('prebook-step1-time-placeholder') }}
      </div>
      <div class="select-icon">
        <img src="~img/icon-time-solid.svg" />
      </div>
    </div>
    <transition name="fade">
      <ul class="options-list" v-show="optionsOpen">
        <li
          class="options-item"
          :class="{ active: item.bookableTime === value, disabled: !item.bookableTime }"
          v-for="(item, index) in options"
          :key="index"
          @click="clickOption(item)"
        >
          <span v-if="item.bookableTime"
            >{{ item.bookableTime }} {{ item.shorter ? $t('prebook-step1-desc7') : '' }}</span
          >
          <span v-else
            >{{ $t('prebook-step1-desc8') }} {{ item.closeStartTime }}
            {{ item.closeEndTime ? `- ${item.closeEndTime}` : '' }}</span
          >
        </li>
        <!-- <li class="options-item" v-if="options.length === 0">暂无数据</li> -->
        <p>{{ $t('prebook-step1-desc6') }}</p>
      </ul>
    </transition>
  </div>
</template>
<script>
  import { clickOutside } from '@/utils/directive.js';
  export default {
    name: 'Select',
    props: {
      options: {
        type: Array,
        default: [],
      },
      value: {
        type: String,
        default: '',
      },
      errorStatus: {
        type: Boolean,
        default: false,
      },
      onFocus: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        optionsOpen: false,
      };
    },
    directives: { clickOutside },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
      openOptions() {
        if (this.onFocus && this.onFocus()) {
          this.optionsOpen = !this.optionsOpen;
        }
        if (!this.onFocus) {
          this.optionsOpen = !this.optionsOpen;
        }
      },
      closeOptions() {
        this.optionsOpen = false;
      },
      clickOption(item) {
        if (item.bookableTime) {
          this.$emit('onChange', item.bookableTime);
          this.closeOptions();
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .select-container {
    position: relative;
    width: 100%;
    .select-wrapper {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid #9eacb5;
      padding: 20px;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &.error {
        border-color: #cc2222;
      }

      .select-content,
      .select-content-placeholder {
        @include font($size: 20px, $weight: 600);
      }
      .select-content-placeholder {
        color: #7f898f;
      }
      .select-icon {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.3s;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }

    .options-list {
      max-height: 300px;
      overflow-y: auto;
      margin-top: 1px;
      width: 100%;
      position: absolute;
      right: 0;
      z-index: 10;
      box-sizing: border-box;
      padding: 20px 20px;
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);

      &::-webkit-scrollbar {
        display: none;
      }

      p {
        margin-top: 5px;
        padding: 10px 15px;
        @include font($size: 16px, $weight: 400);
        line-height: 26px;
      }

      .options-item {
        box-sizing: border-box;
        border-bottom: 1px solid #bec7cc;
        padding: 10px;
        // margin-bottom: 10px;
        font-size: 16px;
        font-weight: 400;
        line-height: 21px;
        color: #163049;
        white-space: nowrap;
        cursor: pointer;
        @include font($size: 20px, $weight: 400);

        &:hover,
        &.active {
          color: #fff;
          background: #163049;
        }

        &.disabled {
          color: #bec7cc;
          background: #eceef0;
          cursor: not-allowed;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    .select-container {
      .select-wrapper {
        padding: 10px 10px;

        .select-content,
        .select-content-placeholder {
          @include font($size: 16px, $weight: 600);
        }
        .select-content-placeholder {
          color: #7f898f;
        }
        .select-icon {
          width: 18px;
          height: 18px;

          img {
            width: 18px;
            height: 18px;
          }
        }
      }

      .options-list {
        max-height: 250px;
        padding: 10px 10px;

        p {
          @include font($size: 12px, $weight: 400);
          line-height: 16px;
        }

        .options-item {
          @include font($size: 16px, $weight: 400);
        }
      }
    }
  }
</style>
